import React, { Suspense } from "react";

import SkeletonLoader from "../common/SkeletonLoader";

interface RemoteComponentWrapperProps {
    children: React.ReactNode;
    errorMessage?: string;
    loadingComponent?: React.ComponentType;
}

class RemoteErrorBoundary extends React.Component<
    { children: React.ReactNode; errorMessage?: string },
    { hasError: boolean }
> {
    constructor(props: any) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error: Error) {
        console.warn("Remote component failed:", error.message);
    }

    render() {
        if (this.state.hasError) {
            return this.props.errorMessage ? (
                <div>{this.props.errorMessage}</div>
            ) : null;
        }
        return this.props.children;
    }
}

export const RemoteComponentWrapper: React.FC<RemoteComponentWrapperProps> = ({
    children,
    errorMessage,
    loadingComponent: LoadingComponent = SkeletonLoader,
}) => {
    return (
        <RemoteErrorBoundary errorMessage={errorMessage}>
            <Suspense fallback={<LoadingComponent />}>{children}</Suspense>
        </RemoteErrorBoundary>
    );
};
